import { Component, OnInit, ViewChild } from '@angular/core';
import { MerchantFilter, MerchantService } from '../merchants/merchant-master/merchant.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators  } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { Router } from '@angular/router';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { CanDisable } from '@angular/material/core';
import { CustomerService } from '../customers/customer-service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { environment } from 'src/environments/environment';
const {defaultCurrency} = environment;

export class SendVelocityConfig {
  "minAmount": number;
  "maxAmount": number;
  "dailyAmount": number;
  "weeklyAmount": number;
  "monthlyAmount": number;
  "dailyFrequency": number;
  "weeklyFrequency": number;
  "monthlyFrequency": number;
  "successiveTransactionCount":number;
  "successiveTransactionSeconds":number;
  "successiveTransactionAmountCount":number;
  "successiveTransactionAmountSeconds":number;
  "transactionType": String;
}

export class ReceiveVelocityConfig {
  "minAmount": number;
  "maxAmount": number;
  "dailyAmount": number;
  "weeklyAmount": number;
  "monthlyAmount": number;
  "dailyFrequency": number;
  "weeklyFrequency": number;
  "monthlyFrequency": number;
  // "successiveTransactionCount":number;
  // "successiveTransactionSeconds":number;
  // "successiveTransactionAmountCount":number;
  // "successiveTransactionAmountSeconds":number;
}

export class WalletVelocityConfig {
  "maxAmount": number;
  "dailyLimit": number;
  "weeklyLimit": number;
  "monthlyLimit": number;
}

export class WithdrawVelocityConfig {
  "minAmount": number;
  "maxAmount": number;
  "dailyAmount": number;
  "weeklyAmount": number;
  "monthlyAmount": number;
  "dailyFrequency": number;
  "weeklyFrequency": number;
  "monthlyFrequency": number
}

export class VelocityConfig {
  "id": String;
  "currency":String;
  "sendVelocityConfig": SendVelocityConfig;
  "walletVelocityConfig": WalletVelocityConfig;
  "withdrawVelocityConfig": WithdrawVelocityConfig;
  "receiveVelocityConfig": ReceiveVelocityConfig;
}

@Component({
  selector: 'app-velocity-check',
  templateUrl: './velocity-check.component.html',
  styleUrls: ['./velocity-check.component.scss']
})
export class VelocityCheckComponent implements OnInit {
@ViewChild('filStatus') private filStatus: NgSelectComponent;
@ViewChild('filSearchMID') private filSearchMID: NgSelectComponent;
@ViewChild('merchantDropDownList') private merchantDropDownList: NgSelectComponent;
@ViewChild('filResellerPartnerId') private filResellerPartnerId: NgSelectComponent; 
@ViewChild('modalTmRule') private modalReportComponent: ModalComponent;
image : any
velocityFormSend !: FormGroup
velocityFormWallet !: FormGroup
velocityFormWithdraw !: FormGroup
defaultCurrencyData : any;

activeTab: any;
sendVelocityConfig : SendVelocityConfig;
walletVelocityConfig: WalletVelocityConfig;
withdrawVelocityConfig: WithdrawVelocityConfig;
receiveVelocityConfig : ReceiveVelocityConfig;
velocityConfig: VelocityConfig;
id :any;
currency:any;
modalConfigReport : ModalConfig;
customerName:any = "";
AgentName: any = "";
MerchantName: any = "";
mobileMerchantField : boolean= true;
merchant :any;
searchMerchantMobileField : string;
mobileAgentField : boolean= true;
searchAgentMobileField : string;
mobileCustomerField : boolean= true;
searchCustomerMobileField : string;
Resultdata : any;
selectedTransactionType: string = 'Domestic'; // Track selected button (Domestic/International)
customerTypeSelected: boolean = false; // Track if a customer type has been selected
isLoading: boolean = false; // Track loading state for API calls

customerId:string;

// Helper method to handle CORS and other API errors
private handleApiError(error: any, userId: string, resetForm: boolean = true): void {
  console.error("API Error:", error);
  this.isLoading = false; // Always stop loading on error
  
  let errorMessage = `Unable to fetch the data for user ${userId}`;
  
  // Check for timeout error
  if (error.name === 'TimeoutError') {
    errorMessage = `Request timed out. Server is not responding. Unable to fetch data for user ${userId}`;
  }
  // Check for network offline
  else if (!navigator.onLine) {
    errorMessage = `Network connection lost. Unable to fetch data for user ${userId}`;
  }
  // Check for CORS error (status 0 with ProgressEvent)
  else if (error.status === 0) {
    errorMessage = `Unable to connect to server. Please check your network connection or server availability. Unable to fetch data for user ${userId}`;
  }
  // Check for other common HTTP errors
  else if (error.status === 404) {
    errorMessage = `Data not found for user ${userId}`;
  }
  else if (error.status === 403) {
    errorMessage = `Access denied. Unable to fetch data for user ${userId}`;
  }
  else if (error.status === 500) {
    errorMessage = `Server error. Unable to fetch data for user ${userId}`;
  }
  else if (error.status === 502 || error.status === 503 || error.status === 504) {
    errorMessage = `Server is currently unavailable. Please try again later. Unable to fetch data for user ${userId}`;
  }
  // Handle business validation errors from backend
  else if (error.error && error.error.message) {
    errorMessage = error.error.message;
  }
  
  // Reset form to initial state if requested
  if (resetForm) {
    this.resetFormToInitialState();
  }
  
  this.alertService.errorAlertWithMessage(errorMessage);
}

// Helper method to safely initialize velocity config
private initializeVelocityConfig(): void {
  this.velocityConfig = new VelocityConfig();
  this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
  this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
  this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
  this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
}

// Helper method to reset form to initial state
private resetFormToInitialState(): void {
  this.id = null;
  this.customerTypeSelected = false;
  this.mobileCustomerField = true;
  this.mobileMerchantField = true;
  this.mobileAgentField = true;
  this.searchCustomerMobileField = "";
  this.searchMerchantMobileField = "";
  this.searchAgentMobileField = "";
  this.customerName = "";
  this.MerchantName = "";
  this.AgentName = "";
  this.customerId = "";
  this.selectedTransactionType = 'Domestic';
  this.initializeVelocityConfig();
  
  // Clear ng-select dropdowns
  setTimeout(() => {
    if (this.filResellerPartnerId) {
      this.filResellerPartnerId.handleClearClick();
    }
    if (this.filSearchMID) {
      this.filSearchMID.handleClearClick();
    }
    if (this.filStatus) {
      this.filStatus.handleClearClick();
    }
  });
}

// Helper method to ensure velocity config sub-objects are initialized
private ensureVelocityConfigInitialized(): void {
  if (!this.velocityConfig) {
    this.velocityConfig = new VelocityConfig();
  }
  if (!this.velocityConfig.sendVelocityConfig) {
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
  }
  if (!this.velocityConfig.receiveVelocityConfig) {
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
  }
  if (!this.velocityConfig.walletVelocityConfig) {
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
  }
  if (!this.velocityConfig.withdrawVelocityConfig) {
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
  }
}

  constructor(private velocityService:MerchantService,private customerService:CustomerService, private formBuilder: FormBuilder, private fb:ReactiveFormsModule,private alertService : AlertService,private router : Router) { }


  ngOnInit() {
    this.defaultCurrencyData = defaultCurrency;
    this.activeTab ="Merchant";
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();

    this.modalConfigReport = {
      modalTitle: "Velocity Rule",
      modalSize: 'xl',
      css : "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.merchantList();

  }

  emptyVelocity:VelocityConfig;

  getVelocityDetailsByMerchant(merchant : String){
    this.mobileMerchantField = true;
    this.searchMerchantMobileField="";
    this.MerchantName= "";
    this.id = null;
    console.log(this.merchantDropDownList);
    if(this.merchantDropDownList != undefined){
      this.merchantDropDownList.handleClearClick();
    }
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    
    if(merchant == undefined){
      return;
    }
    console.log("Selected Merchant :"+ merchant);
    this.id = merchant;
    if(merchant=="CUSTOM"){
      this.mobileMerchantField = false;
      console.log(this.mobileMerchantField)
      return;
    }
    this.isLoading = true;
    this.velocityService.getVelocityConfig(merchant).subscribe({
      next: (res:any) => {
        this.isLoading = false;
        console.log("Velocity Config Data for Merchant : "+JSON.stringify(res));
        console.log(res);
        if(res!=null){
        // this.velocityConfig = res; 
          this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
          this.velocityConfig.receiveVelocityConfig = res.receiveVelocityConfig;
          this.ensureVelocityConfigInitialized();
        }else{
          this.initializeVelocityConfig();
        }
      },
      error: (error) => {
        this.handleApiError(error, merchant.toString());
        // Reset to default config on error
        this.initializeVelocityConfig();
      }
    });
  }

  getVelocityDetailsByAgent(agent:String){
    this.id = null;
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    if(agent == undefined){
      return;
    }
    this.searchAgentMobileField=""
    this.AgentName= "";

    // this.searchAgentMobileField = "";
    this.mobileAgentField = true;

    console.log("Selected Agent :"+ agent);
    this.id = agent;
    if(agent=="CUSTOM"){
      this.mobileAgentField = false;
      return;
    }
    this.isLoading = true;
    this.velocityService.getVelocityConfig(agent).subscribe({
      next: (res:VelocityConfig) => {
        this.isLoading = false;
        console.log("Velocity Config Data for Agent : "+JSON.stringify(res));
        console.log(res);
        if(res!=null){
        this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
        this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
        this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
        this.ensureVelocityConfigInitialized();
        }else{
          this.initializeVelocityConfig();
        }
      },
      error: (error) => {
        this.handleApiError(error, agent.toString());
        // Reset to default config on error
        this.initializeVelocityConfig();
      }
    });
  }


  getVelocityDetailsByCustomer(customer:String){
    // Check if International is selected and CUSTOM type is being selected
    if(customer === 'CUSTOM' && this.selectedTransactionType === 'International'){
      this.alertService.errorAlertWithMessage("CUSTOM type configuration is not allowed for the International transaction type");
      
      // Keep the previous DEFAULT selection if it exists and preserve all form data
      // this.id holds the previous selection because it hasn't been updated yet
      if(this.id && this.id !== 'CUSTOM'){
        // Stay on the same screen with DEFAULT option selected previously
        // Revert the UI selection to the previous valid ID
        const previousId = this.id;
        setTimeout(() => {
          if (this.filResellerPartnerId) {
            this.filResellerPartnerId.writeValue(previousId);
          }
        });
        // Do not change anything else - keep the current state
        return;
      }
      
      // Clear the type selection but keep International button selected
      this.id = null;
      this.customerTypeSelected = false;
      this.mobileCustomerField = true;
      this.searchCustomerMobileField = "";
      this.customerName = "";
      
      // Clear the UI selection
      setTimeout(() => {
        if (this.filResellerPartnerId) {
          this.filResellerPartnerId.handleClearClick();
        }
      });

      // Reset velocity config
      this.velocityConfig = new VelocityConfig();
      this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
      this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
      this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
      this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
      return;
    }

    // Handle clearing of CUSTOM type - also clear mobile number field
    if(customer == undefined && this.id === 'CUSTOM'){
      this.searchCustomerMobileField = "";
      this.customerName = "";
      this.mobileCustomerField = true;
    }

    this.id = null;
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    if(customer == undefined){
      return;
    }
    this.customerTypeSelected = true; // Set flag when customer type is selected
    
    // For DEFAULT customer type, preserve the current transaction type instead of resetting to Domestic
    if(customer !== 'CUSTOM'){
      // Keep the current selectedTransactionType (don't reset to Domestic)
      this.searchCustomerMobileField=""
      this.customerName= "";
      this.mobileCustomerField = true;

      console.log("Selected Customer :"+ customer);
      this.id = customer;
      
      // Call API with current transaction type for DEFAULT selections
      // Only append transactionType for INTERNATIONAL, not for DOMESTIC
      const idWithTransactionType = this.selectedTransactionType === 'International' 
        ? customer + '_' + this.selectedTransactionType.toUpperCase()
        : customer;
      this.isLoading = true;
      this.velocityService.getVelocityConfig(idWithTransactionType).subscribe({
        next: (res:VelocityConfig) => {
          this.isLoading = false;
          console.log("Velocity Config Data for Customer : "+JSON.stringify(res));
          console.log(res);
          if(res!=null){
            this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
            this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
            this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
            this.ensureVelocityConfigInitialized();
          }else{
            this.initializeVelocityConfig();
          }
        },
        error: (error) => {
          this.handleApiError(error, idWithTransactionType.toString());
        }
      });
      return;
    }

    // Handle CUSTOM type selection
    this.searchCustomerMobileField=""
    this.customerName= "";
    this.mobileCustomerField = true;

    console.log("Selected Customer :"+ customer);
    this.id = customer;
    if(customer=="CUSTOM"){
      this.mobileCustomerField = false;
      this.customerTypeSelected = true; // Set flag to true for CUSTOM type to show Domestic/International buttons
      // Ensure transaction type is set to Domestic for CUSTOM type
      this.selectedTransactionType = 'Domestic';
      return;
    }
  }


  SubAnother='Receive';
  switchTabSubAnother(tab: string): void {
    this.SubAnother = tab;
  }

  switchTransactionType(type: string): void {
    // Check if CUSTOM type is selected and International transaction type is being selected
    if(this.id === 'CUSTOM' && type === 'International'){
      this.alertService.errorAlertWithMessage("CUSTOM type configuration is not allowed for the International transaction type");
      // Do not change the selectedTransactionType - keep it as Domestic
      return;
    }
    
    this.selectedTransactionType = type;
    
    // Reset the form when switching between Domestic and International
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    
    // Clear customer mobile field and name when switching transaction type
    this.searchCustomerMobileField = "";
    this.customerName = "";
    this.customerId = "";

    // Call API with transaction type for DEFAULT customer type selections
    if(this.customerTypeSelected && this.id && this.id !== 'CUSTOM'){
      // Only append transactionType for INTERNATIONAL, not for DOMESTIC
      const idWithTransactionType = type === 'International' 
        ? this.id + '_' + type.toUpperCase()
        : this.id;
      this.isLoading = true;
      this.velocityService.getVelocityConfig(idWithTransactionType).subscribe({
        next: (res:VelocityConfig) => {
          this.isLoading = false;
          console.log("Velocity Config Data for Customer with transaction type : "+JSON.stringify(res));
          if(res != null){
            this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
            this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
            this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
            this.ensureVelocityConfigInitialized();
          }else{
            this.initializeVelocityConfig();
          }
        },
        error: (error) => {
          this.handleApiError(error, idWithTransactionType.toString());
          // Reset to default config on error
          this.initializeVelocityConfig();
        }
      });
    }
    // For CUSTOM type, do not auto-call API - user needs to enter mobile and search
  }

  activeTabSub='profile';
  switchTab(tab: string): void {
    this.activeTab = tab;
    if(this.activeTab == 'Merchant'){
      this.SubAnother = 'Receive';
    }else if(this.activeTab == 'Customer'){
      this.SubAnother = 'Send';
      this.selectedTransactionType = 'Domestic'; // Reset to Domestic when Customer tab is selected
      this.customerTypeSelected = false; // Reset the selection flag
    }else{
      this.SubAnother = 'Send';
    }
    this.id = null;
    this.mobileMerchantField = true;
    this.mobileAgentField = true;
    this.mobileCustomerField = true;
    this.filSearchMID.handleClearClick();
    this.filResellerPartnerId.handleClearClick();
    this.filStatus.handleClearClick();
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
  }

  saveMerchantVelocity(data:any){
    console.log("Merchant :    :"+this.id);
    if(this.id == null){
      this.alertService.errorAlertWithMessage("Please Select Type");
      return;
    }
    if(this.id=="CUSTOM"){
      console.log("Merchant Name : "+this.MerchantName);
      if(this.MerchantName=="" || this.MerchantName=="Merchant not found"){
        this.alertService.errorAlertWithMessage("Merchant Not Found");
        return;
      }
      this.velocityConfig.id= this.searchMerchantMobileField;
      console.log("ID : "+this.velocityConfig.id);
    }else{
      console.log(this.velocityConfig);
      this.velocityConfig.id = this.id;
    }

    console.log(this.velocityConfig);

    if(!this.velocityConfig.receiveVelocityConfig.minAmount){
      this.alertService.errorAlertWithMessage("Please Enter Minimum Ticket Size");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Maximum Ticket Size");
      return;
    }

    if(Number(this.velocityConfig.receiveVelocityConfig.minAmount)> Number(this.velocityConfig.receiveVelocityConfig.maxAmount)){
      this.alertService.errorAlertWithMessage("Minimum Ticket Size cannot be greater than Maximum Ticket Size");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.dailyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Limit");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.weeklyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Limit");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.monthlyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Limit");
      return;
    }
    
    if(Number(this.velocityConfig.receiveVelocityConfig.dailyAmount)> Number(this.velocityConfig.receiveVelocityConfig.weeklyAmount)){
      this.alertService.errorAlertWithMessage("Send Daily Limit cannot be greater than Send Weekly Limit");
      return;
    }

    if(Number(this.velocityConfig.receiveVelocityConfig.weeklyAmount)> Number(this.velocityConfig.receiveVelocityConfig.monthlyAmount)){
      this.alertService.errorAlertWithMessage("Send Weekly Limit cannot be greater Send than Monthly Limit");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.dailyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Count");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.weeklyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Count");
      return;
    }

    if(!this.velocityConfig.receiveVelocityConfig.monthlyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Count");
      return;
    }

    if(Number(this.velocityConfig.receiveVelocityConfig.dailyFrequency)> Number(this.velocityConfig.receiveVelocityConfig.weeklyFrequency)){
      this.alertService.errorAlertWithMessage("Send Daily Count cannot be greater than Send Weekly Count");
      return;
    }

    if(Number(this.velocityConfig.receiveVelocityConfig.weeklyFrequency)> Number(this.velocityConfig.receiveVelocityConfig.monthlyFrequency)){
      this.alertService.errorAlertWithMessage("Send Weekly Count cannot be greater than Send Monthly Count");
      return;
    }

    if(!this.velocityConfig.walletVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Maximum Balance");
      return;
    }
    
    this.velocityService.saveVelocityConfig(this.velocityConfig).subscribe((res:boolean)=>{
      console.log("Velocity Config Data : "+JSON.stringify(res));
      console.log(res);

      if(res){
        this.alertService.successAlert("Velocity Configuration Saved Successfully");
      }else{
        this.alertService.simpleAlert("Error While Saving Velocity Configuration");
      }
      
    });

  }
  saveAgentVelocity(data:any){
    console.log("Agent :    :"+this.id);
    if(this.id == null){
      this.alertService.errorAlertWithMessage("Please Select Type");
      return;
    }
    if(this.id=="CUSTOM"){
      console.log("Agent Name : "+this.AgentName);
      if(this.AgentName=="" || this.AgentName=="Agent not found"){
        this.alertService.errorAlertWithMessage("Agent Not Found");
        return;
      }
      this.velocityConfig.id= this.searchAgentMobileField;
      console.log("ID : "+this.velocityConfig.id);
    }else{
      console.log(this.velocityConfig);
      this.velocityConfig.id = this.id;
    }
    console.log(this.velocityConfig.sendVelocityConfig.dailyAmount)
    console.log(this.velocityConfig.sendVelocityConfig.weeklyAmount)
    console.log(this.velocityConfig.sendVelocityConfig.monthlyAmount)

    if(!this.velocityConfig.sendVelocityConfig.minAmount){
      this.alertService.errorAlertWithMessage("Please Enter Minimum Ticket Size");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Maximum Ticket Size");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.minAmount)> Number(this.velocityConfig.sendVelocityConfig.maxAmount)){
      this.alertService.errorAlertWithMessage("Minimum Ticket Size cannot be greater than Maximum Ticket Size");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.dailyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.weeklyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.monthlyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Limit");
      return;
    }
    
    if(Number(this.velocityConfig.sendVelocityConfig.dailyAmount)> Number(this.velocityConfig.sendVelocityConfig.weeklyAmount)){
      this.alertService.errorAlertWithMessage("Send Daily Limit cannot be greater than Send Weekly Limit");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.weeklyAmount)> Number(this.velocityConfig.sendVelocityConfig.monthlyAmount)){
      this.alertService.errorAlertWithMessage("Send Weekly Limit cannot be greater Send than Monthly Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.dailyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.weeklyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.monthlyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Count");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.dailyFrequency)> Number(this.velocityConfig.sendVelocityConfig.weeklyFrequency)){
      this.alertService.errorAlertWithMessage("Send Daily Count cannot be greater than Send Weekly Count");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.weeklyFrequency)> Number(this.velocityConfig.sendVelocityConfig.monthlyFrequency)){
      this.alertService.errorAlertWithMessage("Send Weekly Count cannot be greater than Send Monthly Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionSeconds){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Time");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionCount){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionAmountSeconds){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Amount Time");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionAmountCount){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Amount Count");
      return;
    }


    if(!this.velocityConfig.walletVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Maximum Balance");
      return;
    }
    
    if(!this.velocityConfig.walletVelocityConfig.dailyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Daily Limit");
      return;
    }

    if(!this.velocityConfig.walletVelocityConfig.weeklyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Weekly Limit");
      return;
    }

    if(!this.velocityConfig.walletVelocityConfig.monthlyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Monthly Limit");
      return;
    }

    if(Number(this.velocityConfig.walletVelocityConfig.dailyLimit)> Number(this.velocityConfig.walletVelocityConfig.weeklyLimit)){
      this.alertService.errorAlertWithMessage("Wallet Daily Limit cannot be greater than Wallet Weekly Limit");
      return;
    }

    if(Number(this.velocityConfig.walletVelocityConfig.weeklyLimit)> Number(this.velocityConfig.walletVelocityConfig.monthlyLimit)){
      this.alertService.errorAlertWithMessage("Wallet Weekly Limit cannot be greater than Wallet Monthly Limit");
      return;
    }

    this.velocityService.saveVelocityConfig(this.velocityConfig).subscribe((res:boolean)=>{
      console.log("Velocity Config Data : "+JSON.stringify(res));
      console.log(res);

      if(res){
        this.alertService.successAlert("Velocity Configuration Saved Successfully");
      }else{
        this.alertService.simpleAlert("Error While Saving Velocity Configuration");
      }
      
    });
  }

  saveCustomerVelocity(data:any){
    console.log("Customer :    :"+this.id);
    if(this.id == null){
      this.alertService.errorAlertWithMessage("Please Select Type");
      return;
    }
    if(this.id=="CUSTOM"){
      console.log("Customer Name : "+this.customerName);
      if(this.customerName==""|| this.customerName == "Customer not found"){
        this.alertService.errorAlertWithMessage("Customer Not Found");
        return;
      }
      // Only append transactionType for INTERNATIONAL, not for DOMESTIC
      this.velocityConfig.id = this.selectedTransactionType === 'International' 
        ? this.customerId + '_' + this.selectedTransactionType.toUpperCase()
        : this.customerId;
      console.log("ID : "+this.velocityConfig.id);
    }else{
      console.log(this.velocityConfig);
      // Only append transactionType for INTERNATIONAL, not for DOMESTIC
      this.velocityConfig.id = this.selectedTransactionType === 'International' 
        ? this.id + '_' + this.selectedTransactionType.toUpperCase()
        : this.id;
    }

    console.log(this.velocityConfig.sendVelocityConfig.dailyAmount)
    console.log(this.velocityConfig.sendVelocityConfig.weeklyAmount)
    console.log(this.velocityConfig.sendVelocityConfig.monthlyAmount)

    if(!this.velocityConfig.sendVelocityConfig.minAmount){
      this.alertService.errorAlertWithMessage("Please Enter Minimum Ticket Size");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Maximum Ticket Size");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.minAmount)> Number(this.velocityConfig.sendVelocityConfig.maxAmount)){
      this.alertService.errorAlertWithMessage("Minimum Ticket Size cannot be greater than Maximum Ticket Size");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.dailyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.weeklyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.monthlyAmount){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Limit");
      return;
    }
    
    if(Number(this.velocityConfig.sendVelocityConfig.dailyAmount)> Number(this.velocityConfig.sendVelocityConfig.weeklyAmount)){
      this.alertService.errorAlertWithMessage("Send Daily Limit cannot be greater than Send Weekly Limit");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.weeklyAmount)> Number(this.velocityConfig.sendVelocityConfig.monthlyAmount)){
      this.alertService.errorAlertWithMessage("Send Weekly Limit cannot be greater Send than Monthly Limit");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.dailyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Daily Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.weeklyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Weekly Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.monthlyFrequency){
      this.alertService.errorAlertWithMessage("Please Enter Send Monthly Count");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.dailyFrequency)> Number(this.velocityConfig.sendVelocityConfig.weeklyFrequency)){
      this.alertService.errorAlertWithMessage("Send Daily Count cannot be greater than Send Weekly Count");
      return;
    }

    if(Number(this.velocityConfig.sendVelocityConfig.weeklyFrequency)> Number(this.velocityConfig.sendVelocityConfig.monthlyFrequency)){
      this.alertService.errorAlertWithMessage("Send Weekly Count cannot be greater than Send Monthly Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionSeconds){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Time");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionCount){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Count");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionAmountSeconds){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Amount Time");
      return;
    }

    if(!this.velocityConfig.sendVelocityConfig.successiveTransactionAmountCount){
      this.alertService.errorAlertWithMessage("Please Enter Successive Transaction Amount Count");
      return;
    }


    if(!this.velocityConfig.walletVelocityConfig.maxAmount){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Maximum Balance");
      return;
    }
    
    if(!this.velocityConfig.walletVelocityConfig.dailyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Daily Limit");
      return;
    }

    if(!this.velocityConfig.walletVelocityConfig.weeklyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Weekly Limit");
      return;
    }

    if(!this.velocityConfig.walletVelocityConfig.monthlyLimit){
      this.alertService.errorAlertWithMessage("Please Enter Wallet Monthly Limit");
      return;
    }

    if(Number(this.velocityConfig.walletVelocityConfig.dailyLimit)> Number(this.velocityConfig.walletVelocityConfig.weeklyLimit)){
      this.alertService.errorAlertWithMessage("Wallet Daily Limit cannot be greater than Wallet Weekly Limit");
      return;
    }

    if(Number(this.velocityConfig.walletVelocityConfig.weeklyLimit)> Number(this.velocityConfig.walletVelocityConfig.monthlyLimit)){
      this.alertService.errorAlertWithMessage("Wallet Weekly Limit cannot be greater than Wallet Monthly Limit");
      return;
    }

    // Set transactionType parameter if on Customer tab
    if(this.activeTab === 'Customer'){
      this.velocityConfig.sendVelocityConfig.transactionType = this.selectedTransactionType;
    }

    this.velocityService.saveVelocityConfig(this.velocityConfig).subscribe({
      next: (res:boolean) => {
        console.log("Velocity Config Data : "+JSON.stringify(res));
        console.log(res);

        if(res){
          this.alertService.successAlert("Velocity Configuration Saved Successfully");
        }else{
          this.alertService.simpleAlert("Error While Saving Velocity Configuration");
        }
      },
      error: (error) => {
        this.handleApiError(error, "Customer");
      }
    });
  }

  searchMerchantMobile(){
    console.log("Merchant ID : "+this.merchant.userId);
    console.log("Merchant Name : "+this.merchant.fullName);
    this.MerchantName = this.merchant.fullName;
    this.searchMerchantMobileField = this.merchant.userId;

          console.log("Merchant Name : "+this.MerchantName);
          if(this.MerchantName != ""){
          this.velocityService.getVelocityConfig(this.searchMerchantMobileField).subscribe({
            next: (res:any) => {
              console.log("Velocity Config Data for Merchant : "+JSON.stringify(res));
              console.log(res);
              if(res == null){
                  this.velocityService.getVelocityConfig("DEFAULT_MERCHANT").subscribe({
                    next: (res:VelocityConfig) => {
                      console.log("Velocity Config Data for DEFAULT MERCHANT: "+JSON.stringify(res));
                      console.log(res);
                      this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                      this.velocityConfig.receiveVelocityConfig = res.receiveVelocityConfig;
                      this.ensureVelocityConfigInitialized();
                    },
                    error: (error) => {
                      this.handleApiError(error, "DEFAULT_MERCHANT");
                    }
                  })
              }else{
                this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                this.velocityConfig.receiveVelocityConfig = res.receiveVelocityConfig;
                this.ensureVelocityConfigInitialized();
              }
            },
            error: (error) => {
              this.handleApiError(error, this.searchMerchantMobileField);
            }
          })
          }
  }

  searchAgentMobile(){
    console.log("Mobile : "+this.searchAgentMobileField);
    // this.velocityService.getVelocityName(this.searchAgentMobileField,"AGENT").subscribe((res)=>{
      this.customerService.getCustomerInfoResponseById(this.searchAgentMobileField).subscribe({
        next: (res:any) => {
          if(res.response.status != 200){
            this.AgentName = "Agent not found";
            this.initializeVelocityConfig();
            return;
          }
          
          if(res != "" || res != null || res != undefined){
              this.AgentName = res.response.data.fullName;
              console.log("Agent Name : "+this.AgentName);
              if(this.AgentName != ""){

              this.velocityService.getVelocityConfig(this.searchAgentMobileField).subscribe({
                next: (res:VelocityConfig) => {
                  console.log("Velocity Config Data for Agent : "+JSON.stringify(res));
                  console.log(res); 
                  if(res == null){
                      this.velocityService.getVelocityConfig("DEFAULT_AGENT").subscribe({
                        next: (res:VelocityConfig) => {
                          console.log("Velocity Config Data for DEFAULT AGENT: "+JSON.stringify(res));
                          console.log(res);
                          this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
                          this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                          this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
                          this.ensureVelocityConfigInitialized();
                        },
                        error: (error) => {
                          this.handleApiError(error, "DEFAULT_AGENT");
                        }
                      })
                  }else{
                    this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
                    this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                    this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
                    this.ensureVelocityConfigInitialized();
                  }
                },
                error: (error) => {
                  this.handleApiError(error, this.searchAgentMobileField);
                }
              })
              }
          }
        },
        error: (error) => {
          this.handleApiError(error, this.searchAgentMobileField);
        }
      });
  }

  searchCustomerMobile(){
    // Block CUSTOM type for International transaction type
    if(this.selectedTransactionType === 'International'){
      this.alertService.errorAlertWithMessage("Custom configuration is not allowed for International transactions");
      return;
    }
    
    // Validate mobile number is entered
    if(!this.searchCustomerMobileField || this.searchCustomerMobileField.trim() === ''){
      this.alertService.errorAlertWithMessage("Please enter a mobile number to search");
      return;
    }
    
    console.log("Mobile : "+this.searchCustomerMobileField);
    // this.velocityService.getVelocityName(this.searchCustomerMobileField,"CUSTOMER").subscribe((res)=>{

      this.customerService.getCustomerInfoResponseById(this.searchCustomerMobileField).subscribe({
        next: (res:any) => {
          if(res.response.status != 200){
            this.customerName = "Customer not found";
            this.initializeVelocityConfig();
            return;
          }
          
          if(res != "" || res != null || res != undefined){
              this.customerName = res.response.data.fullName;
              this.customerId = res.response.data.userId;
              console.log("Customer Name : "+this.customerName);
              if(this.customerName != ""){
               // Only append transactionType for INTERNATIONAL, not for DOMESTIC
               const idWithTransactionType = this.selectedTransactionType === 'International' 
                 ? this.customerId + '_' + this.selectedTransactionType.toUpperCase()
                 : this.customerId;
               this.velocityService.getVelocityConfig(idWithTransactionType).subscribe({
                next: (res:VelocityConfig) => {
                  console.log("Velocity Config Data for Customer : "+JSON.stringify(res));
                  console.log(res);
                  if(res == null){
                    // Only append transactionType to DEFAULT_CUSTOMER for INTERNATIONAL
                    const defaultIdWithTransactionType = this.selectedTransactionType === 'International' 
                      ? 'DEFAULT_CUSTOMER_' + this.selectedTransactionType.toUpperCase()
                      : 'DEFAULT_CUSTOMER';
                    this.velocityService.getVelocityConfig(defaultIdWithTransactionType).subscribe({
                      next: (res:VelocityConfig) => {
                        console.log("Velocity Config Data for DEFAULT CUSTOMER : "+JSON.stringify(res));
                        console.log(res);
                        this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
                        this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                        this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
                        this.ensureVelocityConfigInitialized();
                      },
                      error: (error) => {
                        this.handleApiError(error, "DEFAULT_CUSTOMER");
                      }
                    })
                }else{
                  this.velocityConfig.sendVelocityConfig = res.sendVelocityConfig;
                  this.velocityConfig.walletVelocityConfig = res.walletVelocityConfig;
                  this.velocityConfig.withdrawVelocityConfig = res.withdrawVelocityConfig;
                  this.ensureVelocityConfigInitialized();
                } 
                },
                error: (error) => {
                  this.handleApiError(error, this.customerId);
                }
              })
              }
          }
        },
        error: (error) => {
          this.handleApiError(error, this.searchCustomerMobileField);
        }
      });

  }
  
  viewTMRule(){
    return this.modalReportComponent.open();
    // this.router.navigate(['/transactionMonitoringRule']);
  }

  merchantList() {
      const filter: MerchantFilter = {}
      filter.startDate = "";
      filter.endDate = "";
      this.velocityService.getMerchantList("","","","","","","",filter,"ALL",0).subscribe({
        next: (response) => {
          console.log(response);
          this.Resultdata = response.content;
        },
        error: (error) => {
          this.handleApiError(error, "Merchant List");
          this.Resultdata = [];
        }
      })
    }

    merchantDropdown(){
    this.MerchantName="";
    this.searchMerchantMobileField="";
    this.velocityConfig = new VelocityConfig();
    this.velocityConfig.sendVelocityConfig = new SendVelocityConfig();
    this.velocityConfig.receiveVelocityConfig = new ReceiveVelocityConfig();
    this.velocityConfig.walletVelocityConfig = new WalletVelocityConfig();
    this.velocityConfig.withdrawVelocityConfig = new WithdrawVelocityConfig();
    }

}
